import { api } from "./apiClient.tsx";
import { handleApiError } from "./errorHandler.tsx";

export const getDisclaimer = async (language: string): Promise<string> => {
  try {
    const { data } = await api.get("/legal/disclaimer", {
      params: { language },
    });

    if (!data?.content) {
      throw new Error("Disclaimer content missing in response");
    }

    return data.content;
  } catch (error: any) {
    throw handleApiError(error, {});
  }
};

export const getTerms = async (language: string): Promise<string> => {
  try {
    const { data } = await api.get("/legal/terms", {
      params: { language },
    });

    if (!data?.content) {
      throw new Error("Terms content missing in response");
    }

    return data.content;
  } catch (error: any) {
    throw handleApiError(error, {});
  }
};
